import React from 'react';

/**
 * LearningStatsPanel - Display learning statistics
 *
 * Shows:
 * - Total sentences created
 * - Correct/incorrect usage counts
 * - Words moved to mastered
 * - Current and longest streaks
 */
const LearningStatsPanel = ({ stats }) => {
  if (!stats) return null;

  const statItems = [
    {
      label: 'Sentences',
      value: stats.totalSentencesCreated || 0,
      icon: '📝',
      color: 'text-blue-600'
    },
    {
      label: 'Correct',
      value: stats.correctUsages || 0,
      icon: '✓',
      color: 'text-green-600'
    },
    {
      label: 'Incorrect',
      value: stats.incorrectUsages || 0,
      icon: '✗',
      color: 'text-red-600'
    },
    {
      label: 'Mastered',
      value: stats.wordsMovedToMastered || 0,
      icon: '⭐',
      color: 'text-yellow-600'
    },
    {
      label: 'Streak',
      value: `${stats.currentStreak || 0} days`,
      icon: '🔥',
      color: 'text-orange-600',
      subtitle: stats.longestStreak ? `Best: ${stats.longestStreak}` : null
    }
  ];

  // Calculate accuracy percentage
  const totalAttempts = (stats.correctUsages || 0) + (stats.incorrectUsages || 0);
  const accuracy = totalAttempts > 0
    ? Math.round((stats.correctUsages / totalAttempts) * 100)
    : 0;

  return (
    <div className="bg-gray-50 rounded-lg p-3">
      <div className="flex items-center justify-between mb-2">
        <span className="text-xs font-medium text-gray-500 uppercase tracking-wide">
          Learning Progress
        </span>
        {totalAttempts > 0 && (
          <span className="text-xs text-gray-500">
            {accuracy}% accuracy
          </span>
        )}
      </div>

      <div className="grid grid-cols-5 gap-2">
        {statItems.map((item) => (
          <div
            key={item.label}
            className="text-center"
            title={item.subtitle || item.label}
          >
            <div className={`text-lg font-semibold ${item.color}`}>
              {typeof item.value === 'number' ? item.value.toLocaleString() : item.value}
            </div>
            <div className="text-xs text-gray-500 flex items-center justify-center gap-0.5">
              <span>{item.icon}</span>
              <span>{item.label}</span>
            </div>
          </div>
        ))}
      </div>

      {/* Last practice date */}
      {stats.lastPracticeDate && (
        <div className="mt-2 pt-2 border-t border-gray-200">
          <span className="text-xs text-gray-500">
            Last practice: {new Date(stats.lastPracticeDate).toLocaleDateString()}
          </span>
        </div>
      )}
    </div>
  );
};

export default LearningStatsPanel;
